module.exports = __webpack_public_path__ + "static/img/nc_toyota_goodgrade.9cc7540.jpg";